import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentStep: "login",
  userCredentials: null,
};

const authSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setUserCredentials: (state, action) => {
      state.userCredentials = action.payload;
    },
    reset: (state) => {
      state.currentStep = "login";
      state.userCredentials = null;
    },
  },
});

export const { setStep, setUserCredentials, reset } = authSlice.actions;

export default authSlice.reducer;
